import * as Ariakit from '@ariakit/react'
import classnames from 'classnames'
import * as React from 'react'

import { Button } from '../button'
import { useNotification } from './hooks'

interface NotificationProps {
  className?: string
  /**
   * Default button text
   * @default Close
   */
  closeText?: string

  /**
   * Custom buttons. Overrides `closeText`
   */
  actions?: JSX.Element

  /**
   * When set, the notification will automatically close
   */
  timeoutInMs?: number
}

export function Notification({
  className,
  closeText = 'Close',
  actions,
  timeoutInMs,
  children,
}: React.PropsWithChildren<NotificationProps>) {
  const notification = useNotification()

  React.useEffect(() => {
    let timeoutId: number
    if (timeoutInMs) {
      timeoutId = window.setTimeout(() => {
        notification.hide()
      }, timeoutInMs)
    }

    return () => {
      if (timeoutId) {
        clearTimeout(timeoutId)
      }
    }
  }, [notification, timeoutInMs])

  return (
    <div
      className={classnames(
        className,
        'pointer-events-auto flex space-x-4 rounded-md border border-transparent bg-gray-800 px-3 py-2 shadow-modal dark:border-gray-600 dark:shadow-modal-dark'
      )}
    >
      <div className="text-left text-white">{children}</div>
      <div>
        {actions ?? (
          <Button as={Ariakit.DialogDismiss} theme="dark">
            {closeText}
          </Button>
        )}
      </div>
    </div>
  )
}
